import { motion } from 'framer-motion';

interface PreferenceSwitchProps {
  label: string;
  icon: string;
  isEnabled: boolean;
  onToggle: () => void;
}

export function PreferenceSwitch({ label, icon, isEnabled, onToggle }: PreferenceSwitchProps) {
  return (
    <div className="glass-light px-4 py-2.5 rounded-2xl border border-white/5 flex items-center justify-between hover:border-purple-500/10 transition-colors select-none">
      <div className="flex items-center space-x-3 text-left">
        <span className="text-sm">{icon}</span>
        <span className="text-[10px] font-black uppercase tracking-wider text-surface-200">
          {label}
        </span>
      </div>

      {/* Modern sliding switch */}
      <button
        onClick={onToggle}
        className={`w-9 h-5 rounded-full p-0.5 transition-colors duration-300 cursor-pointer ${
          isEnabled ? 'bg-purple-600' : 'bg-slate-800'
        }`}
      >
        <motion.div
          animate={{ x: isEnabled ? 16 : 0 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
          className="w-4 h-4 rounded-full bg-white shadow-md"
        />
      </button>
    </div>
  );
}
export default PreferenceSwitch;
